import { EditorView, NodeView } from 'prosemirror-view'

import Styles from './ListItem.module.scss'
import { Node } from 'prosemirror-model'
import { schema, nodes, StrongNode } from 'prose-core'
import { updateListItemMarkerStyles } from 'common/Prose/nodeViews/utils'

export class ListItem implements NodeView {
  contentDOM: HTMLElement | null = null
  dom: HTMLLIElement | null = null
  getPos: () => number
  view: EditorView

  constructor(node: Node, view: EditorView, getPos: () => number) {
    this.getPos = getPos
    this.view = view

    this.initializeDom(node)
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    setTimeout(() => updateListItemMarkerStyles(this.view, this.getPos(), this.contentDOM!, this.dom!))
  }

  // NOTE: this is necessary so we can update the marker styles AFTER the
  // content dom is attached (in the constructor it's not yet attached, so we
  // can't resolve the styles)
  ignoreMutation({ target, type }: MutationRecord | { target: Element; type: 'selection' }) {
    const isMarkerStyleUpdate = type === 'attributes' && target === this.dom

    return isMarkerStyleUpdate
  }

  update(node: Node) {
    if (node.type === this.view.state.schema.nodes.list_item) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.dom!.dataset.depth = node.attrs.depth
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      setTimeout(() => updateListItemMarkerStyles(this.view, this.getPos(), this.contentDOM!, this.dom!))

      return true
    }

    return false
  }

  private createDomNode(node: StrongNode<typeof nodes.list_item>) {
    const li = document.createElement('li')
    li.classList.add(Styles.listItem)
    li.dataset.depth = node.attrs.depth as any

    const contentDOM = document.createElement('div')
    contentDOM.classList.add(Styles.contentDOM)
    li.appendChild(contentDOM)

    return li
  }

  private initializeDom(node: Node) {
    if (node.type === schema.nodes.list_item) {
      this.dom = this.createDomNode(node as StrongNode<typeof nodes.list_item>)
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.contentDOM = this.dom.lastChild! as HTMLElement

      return true
    }

    return false
  }
}
